<!-- 运营公众号下拉搜索 -->
<template>
<div>
	<a-select
		:style="{'width': s_width?s_width:'200px'}"
		placeholder="请选择公众号"
		:filter-option="false"
		@change="handleChangeB"
		:getPopupContainer="getsPopupContainer" 
		@popupScroll="popupScrollCEshi" 
		showSearch
		:allowClear="page_type == 'gzhFans'?false : true"
		@search="selectZhSearch"
		:not-found-content="s_fetching ? undefined : null" 
		@blur="zhBlur" 
		:value="r_adv_id"
	  >
		<a-spin v-if="s_fetching" slot="notFoundContent" size="small" />
		<a-select-option v-for="(item,index) in selectGgData" :key="item.id" :value="item.id">
		  {{item.gzh_name}}
		</a-select-option>
		<a-select-option v-if="loading_more_hint" value="-0-">
			<div style="color:rgb(98, 168, 234)">加载更多中...</div>
			
		</a-select-option>
	</a-select>
	
</div>
</template>

<script>
import { opeGzhList, getOperateGzh } from '@/request/api'
export default {
	name: 'searchSelect',
	props: ['page_type','s_width'],
	data(){
		return {
			r_adv_id: [], // 选择的广告账户
			selectGgData: [], // 选择广告账户
			s_page: 1,
			s_limit: 100,
			s_adv_name: "", // 下拉选择框的搜索字段
			s_fetching: false, // 用于控制提示
			blurGgData: [], // 保存一份，用于失去焦点后，回复原来的数值
			loading_more_control: true, // 上拉加载更多控制
			loading_more_hint: false, // 上拉加载更多的提示
			
			r_page: 1,
			r_pageSize: 50,
			r_gzh_name: '',
			
			r_channel_id: undefined, // 渠道ID
		}
	},
	mounted(){
		this.opeGzhSearch()
		console.log("page-type",this.page_type)
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		
		opeGzhSearch(){
			let that = this
			getOperateGzh({
				page: that.s_page,
				limit: that.s_limit,
				gzh_name: that.r_gzh_name, // 公众号名称
			}).then(res=>{
				// console.log('运营公众号',res)
				that.selectGgData = res.data.data.data
				that.blurGgData = res.data.data.data
				
				// 粉丝列表
				if(that.page_type == 'gzhFans'){ 
					that.handleChangeB(that.selectGgData[0].id)
				}
			})
		},
		getfilterGzh(c_id){ // 带上渠道等参数，来获取公众号
			let that = this
			that.s_page = 1
			that.r_channel_id = c_id
			getOperateGzh({
				page: that.s_page,
				limit: that.s_limit,
				channel_id: that.r_channel_id, // 渠道ID
			}).then(res=>{
				// console.log('运营公众号',res)
				that.selectGgData = res.data.data.data
				that.blurGgData = res.data.data.data
				
			})
		},
		handleChangeB(e){ // 选择广告账户
			// console.log(e);
			this.r_adv_id = e
			// 其他页面正常情况
			this.$emit('openGzhSelect', e)
			
			if(this.page_type == 'gzhFans'){ // 粉丝列表页面，需要把公众号名字也传上去
				let g_name = ""
				this.selectGgData.forEach(res=>{
					if(res.id == e){
						g_name = res.gzh_name
					}
				})
				// console.log("g_name",g_name)
				this.$emit('openGzhName', g_name)
			}
		},
		popupScrollCEshi(e){ // 上拉触底加载更多
			// console.log(e.target.scrollHeight);
			// console.log(e.target.scrollTop);
			// console.log(e.target.scrollHeight - e.target.scrollTop);
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.loading_more_control){ // 节流，保证这期间只执行一次
					this.loading_more_hint = true
					this.loading_more_control = false
					let that = this
					that.s_page = that.s_page + 1
					console.log("上拉触底加载更多");
					getOperateGzh({
						page: that.s_page,
						limit: that.s_limit,
						gzh_name: that.s_adv_name,
						channel_id: that.r_channel_id, // 渠道ID
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.selectGgData 
						that.loading_more_hint = false
						that.s_fetching = false
						
						if(that.selectGgData.length < res.data.data.total){
							that.selectGgData = data.concat(res.data.data.data)
							that.loading_more_control = true
						}
					})
				}
			}
		},
		// 选择框搜索-选择广告账户
		selectZhSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.selectGgData = []
			that.s_fetching = true
			that.s_adv_name = e
			
			getOperateGzh({
				page: 1,
				limit: that.s_limit,
				gzh_name: e,
				channel_id: that.r_channel_id, // 渠道ID
			}).then(res=>{
				console.log('选择',res);
				that.s_page = 1
				that.selectGgData = res.data.data.data
				that.s_fetching = false
			})
		},
		// 失去焦点
		zhBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.s_page = 1
			that.s_adv_name = '' // 清空
			that.selectGgData = that.blurGgData 
			
			that.loading_more_control = true
		},
	}
}
</script>

<style scoped>
</style>